import { create } from 'zustand';
import { CalendarEntity, WellbeingAwarenessDaysCalendarPage } from '@/graphql/generated/graphql';
import { toast } from '@/components/ui/use-toast';
import {
  getPage,
  getWellbeingCalendar,
} from '@/services/wellbeing-awareness-days-calendar/wellbeing-awareness-days-calendar.service';

type AdminStore = {
  loading: boolean;
  page: WellbeingAwarenessDaysCalendarPage | null;
  calendar: CalendarEntity | null;
  onInit: () => Promise<void>;
  error: string | null;
};

export const useCalendarStore = create<AdminStore>()((set) => ({
  page: null,
  calendar: null,
  loading: true,
  error: null,
  onInit: async () => {
    set({ loading: true, error: null });
    try {
      const [pageResponse, calendarResponse] = await Promise.all([getPage(), getWellbeingCalendar()]);
      set({ page: pageResponse.page, calendar: calendarResponse.data as CalendarEntity });
    } catch (error) {
      toast({
        title: 'Error',
        description: `Failed to fetch calendar ${error}`,
        variant: 'destructive',
      });
      set({ error: error as string });
    } finally {
      set({ loading: false });
    }
  },
}));
